import { apiCap } from "@gik/api";
import { useTaxonomies } from "@gik/api/give/taxonomies";
import { FetchProvider } from "@gik/core/components/DynamicComponent/FetchProvider";
import type { WordpressTaxonomy } from "@gik/core/models/wordpress/WordpressTaxonomy";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import type { GiveTaxonomyType } from "@gik/shop/types/GiveTaxonomyType";
import React from "react";
import type { TaxonomyNavProps } from ".";
import { TaxonomyNav, TaxonomyNavSkeleton } from ".";

export type TaxonomyNavWithDataProps = {
	taxonomyType: GiveTaxonomyType;
	items?: WordpressTaxonomy[];
} & TaxonomyNavProps;

function TaxonomyNavWithDataComp(props: TaxonomyNavWithDataProps) {
	const { items, taxonomyType } = props;

	const useFetch = () => {
		return useTaxonomies(
			taxonomyType,
			{ page: 1, perPage: apiCap },
			{
				fallbackData: items,
			},
		);
	};

	return (
		<FetchProvider
			fetch={useFetch}
			loadingComponent={<TaxonomyNavSkeleton {...props} />}
		>
			{({ data }) => <TaxonomyNav {...props} items={data} />}
		</FetchProvider>
	);
}

export const TaxonomyNavWithData = withComponentErrorBoundary(
	TaxonomyNavWithDataComp,
);
